/**
 * 作品案例相关接口
 */

import { get, post } from '@fe/common/lib/ajax';

/**
 * 保存关键字
 * @param {string} keyword 关键词
 */
export async function saveKeyword(keyword) {
  return await post('/api/store/preview/saveKeyword', { keyword });
}

/**
 * 通过关键字ID查询关键字
 * @param {string} id 关键字ID
 */
export async function getKeyWord(id) {
  return await get('/api/store/preview/keyWord', { id });
}

/**
 * 获取热门关键词
 * @param {number} pageSize
 */
export async function getHotWords(pageSize) {
  return await get('/api/store/preview/hotList', { pageSize });
}

/**
 * 获取相关关键词
 * @param {string} keyword 关键词
 * @param {number} pageSize
 *
 */
export async function getRelWords(keyword, pageSize) {
  return await get('/api/store/preview/relList', { keyword, pageSize });
}

/**
 * 获取搜索案例列表
 * @param {*} opts
 */
export async function getSearchList(opts) {
  return await get(`/api/store/preview/getSearchList`, opts);
}

/**
 * 获取精品案例列表
 * @param {number} caseType 案例类型 1 精品推荐 2 精选案例推荐
 * @param {number} pageSize 每页条数
 */
export async function getCaseList(pageSize, caseType) {
  return await get('/api/store/preview/getCaseList', { pageSize, caseType });
}

/**
 * 获取搜索框封面图
 */
export async function getCover() {
  return await get('/api/store/template/mainfigure');
}
